<p-block-ui [blocked]="loading" [target]="content"/>
<app-blockable-div #content>

  <div class="slider-manager-container">
    <h2>Carosello della home page</h2>
    <p>Seleziona fino a 5 film da visualizzare nello slider. Puoi riordinarli trascinandoli.</p>

    <p>
      Aggiungi un film allo slider
      <app-movie-selector (movieSelected)="onMovieSelected($event)"/>
    </p>


    <p-block-ui [blocked]="loadingData" [target]="blockableDiv"/>
    <app-blockable-div #blockableDiv>
      <div class="selected-movies mt-8" *ngIf="selectedMovies.length > 0">
        <h3>Film selezionati ({{ selectedMovies.length }}/{{ maxMovies }})</h3>

        <p-orderList [value]="selectedMovies" [dragdrop]="true" header="Trascina per riordinare"
                     [listStyle]="{ 'max-height': '800px' }"
                     (onReorder)="onMoviesReordered()"
        >
          <ng-template let-item pTemplate="item">
            @let movie = obj(item);
            <div class="movie-item">
              <img [src]="movie.sliderImageFullPath" class="movie-poster"/>
              <div class="movie-details">
                <h4>{{ movie.title }}</h4>
                <p>{{ movie.year }}</p>
                <p>{{ movie.sliderSequence }}</p>
                <app-action-button type="delete" [textButton]="true" (click)="onDelete(movie)"/>
                <app-action-button type="edit" [textButton]="true" (click)="onEdit(movie)"/>
              </div>
            </div>
          </ng-template>
        </p-orderList>

        <div class="actions">
          <app-action-button type="save" [textButton]="true" (click)="save()" label="Salva il carosello"/>
        </div>
      </div>
    </app-blockable-div>

    <div class="empty-state" *ngIf="selectedMovies.length === 0">
      <p>Nessun film selezionato. Usa il selettore sopra per aggiungere film.</p>
    </div>

  </div>
</app-blockable-div>
